import { render, staticRenderFns } from "./EmailResponseView.vue?vue&type=template&id=698b99d3&scoped=true&"
import script from "./EmailResponseView.vue?vue&type=script&lang=js&"
export * from "./EmailResponseView.vue?vue&type=script&lang=js&"
import style0 from "./EmailResponseView.vue?vue&type=style&index=0&id=698b99d3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b99d3",
  null
  
)

export default component.exports